<template>
    <div>
        <div style="background: #222222">
            <img src="../../assets/unifun/solution/12.png" style="width: 100%;height: auto;display: block" alt="">
        </div>
        <div style="background: #222222;" class="center solution-info-padding-70">
            <div class="solution-info-title">
                <h2 class="white  font-28">
                    <img src="../../assets/img/1.png" alt="" width="31"> <span style="margin:0 20px">系统简介</span> <img
                        src="../../assets/img/2.png" width="31" alt="">

                </h2>
                <div class="margin-top-20 line-height-30 white">
                    华方智能水泥厂巡检解决方案以机器人为核心，自研视觉识别技术、音频检测技术、热成像处理技术、多传感器融合技术、人工智能识别技术等，实现对水泥厂场景的全方位自主巡检和实时监控。
                </div>

            </div>
        </div>
        <div class="padding-20 margin-top-20 background-white ">
            <div class="index-div-content">
                <div class="margin-bottom-20 center font-28" style="color: #1B1B1B">
                    <img src="../../assets/img/1.png" alt="" width="31"> <span style="margin:0 20px">系统架构</span> <img
                        src="../../assets/img/2.png" width="31" alt="">

                </div>
                <div>
                    <img src="../../assets/unifun/solution/13.png"
                         style="width: 100%;height: auto;display: block;margin: 0 auto" alt="">
                </div>
            </div>

        </div>
        <div class="padding-20 margin-top-20 background-white ">
            <div class="index-div-content">
                <div class="margin-bottom-20 center font-28" style="color: #1B1B1B"><img src="../../assets/img/1.png"
                                                                                         alt="" width="31"> <span
                        style="margin:0 20px">系统功能</span> <img src="../../assets/img/2.png" alt="" width="31"></div>
                <br><br>
                <div>
                    <img src="../../assets/unifun/solution/14.png"
                         class="solution-function-img" alt="">
                </div>
            </div>

        </div>
     <example :info="info"></example>
    </div>
</template>

<script>
    import Swiper from 'swiper';
        import example from "../commom/example";
    export default {
        name: "electricity",
        components:{example},
        data() {
            return {
                info:[
                    {
                        title:'某金隅水泥有限公司皮带输送机智能巡检项目',
                        content:'该巡检项目共三条皮带，总巡检里程为884米。机器人在皮带下方巡检，对水泥厂环境、皮带、托辊、电机、减速器、辊筒、行人等进行实时监测和预警，机器人系统通过收集现场温湿度、环境噪音、氧气、一氧化碳、二氧化碳、氨气、烟雾、PM2.5、PM10等数据进行分析和预警，降低巡检成本，实现无人巡检模式，可以减少巡检人员的次生灾害发生。',
                        url:'https://unifun-video.oss-cn-beijing.aliyuncs.com/video/09-%E6%A0%87%E5%87%86Cicada%E5%85%85%E7%94%B5-%E4%B8%AD%E5%AE%89%E5%90%89%E6%B3%B0-%E5%86%85%E8%.mp4',
                        imgUrl:'https://unifun-video.oss-cn-beijing.aliyuncs.com/image/solution/11.png'
                    },
                ]
            }
        },
    }
</script>

<style scoped lang="scss">
    .index-inyong {
        background: url(../../assets/unifun/solution/11.png) 100% 100% no-repeat;
        background-size: cover;
        height: 400px;
    }

    #swiperBox1 {
        position: relative;
        width: 100%;
        overflow: hidden;

        .swiper-button-prev, .swiper-button-next {
            bottom: 0px;
            top: auto;
            width: 32px;
            height: 32px;
            background: #005DAB;
            line-height: 32px;
            text-align: center;
            color: white;
        }

        .swiper-button-prev {
            left: calc(50% - 32px);
        }

        .swiper-button-next {
            left: calc(50% + 1px);
        }
    }
</style>